// empty (null-loader)


//////////////////
// WEBPACK FOOTER
// ../css/global.sass
// module id = 510
// module chunks = 0